import React, { useEffect, useState } from "react";
import { render } from "react-dom";
import { renderToString } from "react-dom/server";
import jsPDF from "jspdf";
import { useSearchParams } from "react-router-dom";
import { format } from "date-fns";
import ReportTemplate from "./ReportTemplate";

const styles = {
  fontFamily: "sans-serif",
  textAlign: "center",
};
const page = {
  /*  pageBreakAfter: "always", */
  fontSize: 10,
  background: "white",
  padding: 10,
};
const td = {
  borderBottom: "1px solid #ddd",
  paddingBottom: 10,
  paddingTop: 10,
};
const th = {
  borderBottom: "1px solid #ddd",
  paddingBottom: 10,
  paddingTop: 10,
};
const colstyle = {
  width: "30%",
};
const tableStyle = {
  width: "100%",
};
const Jspdfrender = (props) => {
  let [searchParams, setSearchParams] = useSearchParams();

  const [tablearr, setTablearr] = useState([]);
  //use effects
  useEffect(() => {
    setTablearr(props.pdfarr);
  }, []);
  const Prints = () => (
    <div style={page}>
      <h3 style={{ textAlign: "start" }}>Invoice</h3>
      <div className="d-flex">
        <div className="flex-fill">
          <h6>Letscool Engineering pte lte</h6>
          <div>11 Mandai Estate, #05-15</div>
          <div>Singapore 729908</div>
          <h6 className="pt-2">Bill To</h6>
          <div>{props.client_name}</div>
          <div>{props.client_address}</div>
        </div>
        <div>
          <div>
            Invoice No : #
            {new Date().getDate() +
              "" +
              new Date().getMonth() +
              "" +
              new Date().getFullYear() +
              "" +
              new Date().getHours() +
              "" +
              new Date().getMinutes()}
          </div>
          <div>Invoice Date :{format(new Date(), "dd/MM/yyyy")} </div>
        </div>
      </div>

      <p></p>
      <table className="" style={tableStyle}>
        {/* <colgroup>
          <col span="1" style={colstyle} />
          <col span="1" style={colstyle} />
        </colgroup> */}
        <thead>
          <tr className="warning">
            <th style={{ width: 20 }}>#</th>
            <th style={{ width: 100 }}>Date</th>
            <th>Description</th>
            <th style={{ width: 100 }}>Signature</th>
            <th style={{ width: 50 }}>Price</th>
          </tr>
        </thead>
        <tbody>
          {tablearr.map((tablearr, index) => (
            <tr key={index}>
              <td style={td}>{index + 1}</td>
              <td style={td}>
                {format(new Date(tablearr.createdAt), "dd/MM/yyyy")}
              </td>
              <td style={td}>{tablearr.service_list}</td>
              <td style={td}>
                <img style={{ width: 100 }} src={tablearr.approval_signature} />
              </td>
              <td style={td}>${tablearr.total_amount}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <h6 style={{ textAlign: "end", marginTop: 20 }}>
        Total Amount - ${props.total_amount}
      </h6>
      <p>*This is computer generated invoice</p>
    </div>
  );

  const generatePDF = () => {
    const stringdiv = renderToString(<Prints />);

    var elementHTML = stringdiv;
    var doc = new jsPDF("p", "pt", "a4");
    doc.html(elementHTML, {
      callback: function (doc) {
        // Save the PDF
        const filename = new Date().toDateString() + "-invoice.pdf";
        var pageCount = doc.internal.getNumberOfPages();
        /*   doc.addPage(); */
        doc.save(filename);
      },
      margin: [10, 10, 10, 10],
      autoPaging: "text",
      x: 0,
      y: 0,
      width: 570, //target width in the PDF document
      windowWidth: 650, //window width in CSS pixels
    });
  };
  return (
    <div>
      {/* <button onClick={print}>print</button> */}
      <div className="pb-3">
        <button className="btn btn-dark" onClick={generatePDF}>
          <i className="fa fa-print"></i> Download
        </button>
      </div>
      <div>
        <Prints />
      </div>
    </div>
  );
};

export default Jspdfrender;
